import { DataSetValue } from '../../types/DataSetValue';
import CDGridPro from '../../components/CDGridPro';
import Utils from '../../components/Utils';

export default function SalesDataMAIDDataGrid(props: { rows: DataSetValue[] }) {
    return (
        <CDGridPro
            showToolbar={false}
            variant="contained"
            columnHeaderHeight={75}
            rowHeight={75}
            columns={[
                {
                    width: 320,
                    field: 'maid',
                    headerName: 'MAID',
                },
                {
                    width: 120,
                    field: 'saleDate',
                    headerName: 'Date of Visit',
                    valueGetter: (value: Date) => {
                        return Utils.formatDate(value);
                    },
                },
                {
                    width: 120,
                    field: 'deviceType',
                    headerName: 'Device Type',
                },
                {
                    width: 180,
                    field: 'segmentId',
                    headerName: 'Segment ID',
                },
            ]}
            rows={props.rows}
        />
    );
}
